/** The bare, lowercased address in `jane@acme.com` or `Jane Cooper <Jane@Acme.com>`. */
export function emailAddressOf(value: unknown): string {
  const text = value != null ? String(value) : '';
  return (text.match(/<([^>]+)>/)?.[1] ?? text).trim().toLowerCase();
}
